module.exports = __webpack_public_path__ + "static/media/m-top-bg.c62a5244.svg";